module.exports = "/_next/static/images/shiba-e85ed5df6556448829a85289ab4b3882.svg";